import React from 'react';
import { ProfileDetailsModal } from '@/components/FunctionalArea/Modal/ProfileModal/ProfileDetailsModal.component';
import { GenericTabNavigator } from '@/components/Map/GenericTabNavigator/GenericNavigator.component';
import { ONE, ZERO } from '@/constants/common';
import { ProfileAuthTokensModal } from '@/components/FunctionalArea/Modal/ProfileModal/ProfileAuthTokensModal.component';
import { openAuthTokens, openDetails } from '@/redux/modal/UserProfile/userProfile.slice';
import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { userProfileSelector } from '@/redux/modal/UserProfile/userProfile.selector';
import { useAppSelector } from '@/redux/hooks/useAppSelector';

const PROFILE_TABS = ['Profile', 'API Tokens'];
export const ProfileModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { activeTab } = useAppSelector(userProfileSelector);

  const handleTabChange = (tabId: number): void => {
    if (tabId === ZERO) {
      dispatch(openDetails());
    }
    if (tabId === ONE) {
      dispatch(openAuthTokens());
    }
  };

  return (
    <div className="min-h-[627px] w-full overflow-auto bg-white">
      <GenericTabNavigator
        className="bg-white p-[24px]"
        activeTabId={activeTab}
        onTabChange={handleTabChange}
        tabNames={PROFILE_TABS}
      />
      {activeTab === ZERO && <ProfileDetailsModal />}
      {activeTab === ONE && <ProfileAuthTokensModal />}
    </div>
  );
};
